import { colors } from '../tokens/colors';

export const darkTheme = {
  '--bg-color': '#000000',
  '--bg-color-secondary': '#1c1c1e',
  '--text-primary': '#ffffff',
  '--text-secondary': '#8e8e93',
  '--primary-color': '#0A84FF',
  '--hover-color': 'rgba(10, 132, 255, 0.1)',
  '--border-color': 'rgba(255, 255, 255, 0.2)',
  '--divider-color': 'rgba(255, 255, 255, 0.1)',
  colors: {
    ...colors,
    text: {
      primary: '#FFFFFF',
      secondary: '#8899A6',
      disabled: '#38444D'
    },
    background: {
      default: '#15202B',
      secondary: '#1C2938',
      tertiary: '#38444D'
    },
    border: '#38444D'
  }
}; 